export default __webpack_public_path__ + "static/media/checkWhite.18feead3.svg";